module.exports = __webpack_public_path__ + "static/media/suspension.90e3fbc4.mp3";